/** Resolve active company id from persisted session. */
export function getCompanyId() {
  try {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userObj = JSON.parse(storedUser);
      return userObj?.company_id || localStorage.getItem('company_id');
    }
  } catch {
    // ignore
  }
  return localStorage.getItem('company_id');
}
